import api from "./api"

export const getUsers = async (params = {}) => {
  try {
    const response = await api.get("/users", { params })
    return response.data
  } catch (error) {
    console.error("Error fetching users:", error)
    throw error
  }
}

export const getUser = async (id) => {
  try {
    const response = await api.get(`/users/${id}`)
    return response.data
  } catch (error) {
    console.error(`Error fetching user ${id}:`, error)
    throw error
  }
}

export const getUserProfile = async () => {
  try {
    const response = await api.get("/users/profile")
    return response.data
  } catch (error) {
    console.error("Error fetching user profile:", error)
    throw error
  }
}

export const createUser = async (userData) => {
  try {
    const response = await api.post("/users", userData)
    return response.data
  } catch (error) {
    console.error("Error creating user:", error)
    throw error
  }
}

export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/users/${id}`, userData)
    return response.data
  } catch (error) {
    console.error(`Error updating user ${id}:`, error)
    throw error
  }
}

export const updateUserProfile = async (userData) => {
  try {
    const response = await api.put("/users/profile", userData)
    return response.data
  } catch (error) {
    console.error("Error updating user profile:", error)
    throw error
  }
}

export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/users/${id}`)
    return response.data
  } catch (error) {
    console.error(`Error deleting user ${id}:`, error)
    throw error
  }
}

export const changePassword = async (passwordData) => {
  try {
    const response = await api.post("/users/change-password", passwordData)
    return response.data
  } catch (error) {
    console.error("Error changing password:", error)
    throw error
  }
}

export const resetUserPassword = async (id, newPassword) => {
  try {
    const response = await api.post(`/users/${id}/reset-password`, newPassword ? { newPassword } : {})
    return response.data
  } catch (error) {
    console.error(`Error resetting password for user ${id}:`, error)
    throw error
  }
}

export const searchUsers = async (query, params = {}) => {
  const response = await api.get("/users/search", {
    params: {
      query,
      ...params,
    },
  })
  return response.data
}

